import React from 'react';
import { ControlledDateTimePickerDatatestid } from '../../../constants/index.js';
import { CalendarMonthDays } from './CalendarMonthDays.js';
import { CalendarWeekDays } from './CalendarWeekDays.js';
import { StyledBody } from './Styleds.js';

interface CalendarBodyPropsT {
  weekRowsNum: number;
}
export const CalendarBody = React.memo(({ weekRowsNum }: CalendarBodyPropsT) => (
  <span
    role="grid"
    aria-label="calendar"
    aria-colcount={7}
    aria-rowcount={weekRowsNum}
    data-testid={ControlledDateTimePickerDatatestid.CALENDAR.TABLE_WRAPPER}
  >
    <CalendarWeekDays />
    <StyledBody>
      <CalendarMonthDays />
    </StyledBody>
  </span>
));
